import AsyncStorage from "@react-native-async-storage/async-storage";
import { clientConfigPath } from "../../config/Constant";
// import { setAllEventsList } from "../Reducers/diningReducer";
import { ClientInfoLS_Key, Events_Clients_Details_tempKey } from "../../Apps/reservation";



export const getAllAvailableEvents = (callback=()=>{}) => {
    return async (dispatch, getState) => {
        const sessionToken = await AsyncStorage.getItem("sessionToken");
        const reservationNumber = await AsyncStorage.getItem("sessionReservationNumber");
        const guestToken = await AsyncStorage.getItem("guestToken");
        
        try {
            let response = await clientConfigPath.post(`/restaurantTableBooking/getAllEvents`, {
                header: {
                    sessionToken,
                    reservationNumber: reservationNumber,
                    guestToken: guestToken
                },
                payload: {

                }
            })

            if(response.data?.header?.status?.code == "SUCCESS"){
                // dispatch(setAllEventsList(formatResponseForAvailableEvents(response.data?.payload?.data?.venues)))
                callback(true, response.data?.payload?.data?.venues)
            } else {
                callback(false, response.data?.header?.status?.message);
            }
        } catch (error) {
            const errorMessage = error.response?.data?.header?.status?.msg || error.message || "Something went wrong";
            callback(false, errorMessage);
        }
    }
}


export const getMyEventsReservations = (callback=()=>{}) => {
    return async (dispatch, getState) => {
        try {
            const sessionToken = await AsyncStorage.getItem("sessionToken");
            const reservationNumber = await AsyncStorage.getItem("sessionReservationNumber");
            const guestToken = await AsyncStorage.getItem("guestToken");

            let payload={};

            const clientId = await AsyncStorage.getItem(ClientInfoLS_Key);
            const clientDetailsString = await AsyncStorage.getItem(Events_Clients_Details_tempKey)
            const clientDetails= JSON.parse(clientDetailsString);

            
            if (clientId && clientId !='' && clientId != "null" ) {
                payload.clientId = clientId; 
            } else {
                payload.guestName= clientDetails?.firstName + ' ' + clientDetails?.lastName;
                payload.guestEmail= clientDetails?.email;
            }
        

            let response = await clientConfigPath.post(`/restaurantTableBooking/getAllReservations`, {
                header: {
                    sessionToken,
                    reservationNumber: reservationNumber,
                    guestToken: guestToken,
                },
                payload
            })

            if(response.data?.header?.status?.code == "SUCCESS" && response.data?.payload?.data?.results?.length){
                callback(true, response.data?.payload?.data?.results);
            } else {
                callback(false, response.data?.header?.status?.message);
            }
        } catch (error) {
            const errorMessage = error.response?.data?.header?.status?.msg || error.message || "Something went wrong";
            callback(false, errorMessage)
        }
    }
}


export const bookEvent = (payload, callback = ()=>{}) => {
    return async (dispatch, getState) => {
        const sessionToken = await AsyncStorage.getItem("sessionToken");
        const reservationNumber = await AsyncStorage.getItem("sessionReservationNumber");
        const guestToken = await AsyncStorage.getItem("guestToken");
    
    
        let payload_ = {
            "header": {
                sessionToken,
                "reservationNumber": reservationNumber,
                "guestToken": guestToken,
            },
            payload
        }
    
        try {
            let response = await clientConfigPath.post(`/restaurantTableBooking/bookEvent`, payload_);
            if(response.data?.header?.status?.code == "SUCCESS"){
                const clientId = response.data.payload.data.clientId;
                if(clientId){
                    await AsyncStorage.setItem(ClientInfoLS_Key, clientId);
                } else {
                    await AsyncStorage.setItem(Events_Clients_Details_tempKey, JSON.stringify({
                        firstName: payload.firstName,
                        lastName: payload.lastName,
                        email: payload.email,
                        phoneNumber: payload.phoneNumber
                    }))
                }
                callback(true);
            } else {
                callback(false, response.data?.header?.status?.message || "Something went wrong");
            }
        } catch (error) {
            const errorMessage = error.response?.data?.header?.status?.msg || error.message || "Something went wrong";
            callback(false, errorMessage)
        }
    }
}

export const cancelEvent = (payload, callback=( )=>{}) => {
    return async (dispatch, getState) => {
        const sessionToken = await AsyncStorage.getItem("sessionToken");
        const reservationNumber = await AsyncStorage.getItem("sessionReservationNumber");
        const guestToken = await AsyncStorage.getItem("guestToken");
    
    
        let payload_ = {
            "header": {
                sessionToken,
                "reservationNumber": reservationNumber,
                "guestToken": guestToken,
            },
            payload
        }
    
        try {
            let response = await clientConfigPath.post(`/restaurantTableBooking/cancelReservation`, payload_)
            if(response.data?.header?.status?.code == "SUCCESS"){
                callback(true, response.data?.header?.status?.msg || "Reservation cancelled successfully");
            } else {
                callback(false, response.data?.header?.status?.message || "Something went wrong");
            }
        } catch (error) {
            const errorMessage = error.response?.data?.header?.status?.msg || error.message || "Something went wrong";
            callback(false, errorMessage)
        }
    }
}


export const getAvailableDateTime = (payload, callback=( )=>{}) => {
    return async (dispatch, getState) => {
        const sessionToken = await AsyncStorage.getItem("sessionToken");
        const reservationNumber = await AsyncStorage.getItem("sessionReservationNumber");
        const guestToken = await AsyncStorage.getItem("guestToken");
    
    
        let payload_ = {
            "header": {
                sessionToken,
                reservationNumber,
                guestToken,
            },
            payload
        }
    
        try {
            let response = await clientConfigPath.post(`/restaurantTableBooking/getVenueAvailability`, payload_)
            if(response.data?.header?.status?.code == "SUCCESS"){
                callback(true, response.data?.payload)
            } else {

            }
        } catch (error) {
            const errorMessage = error.response?.data?.header?.status?.msg || error.message || "Something went wrong";
            callback(false, errorMessage)
        }
    }
}



export const formatResponseForAvailableEvents = (venues) => {
    try{
        let formattedData={};
        for (const venue of venues) {
            const venueName = venue.name;
            const venueId = venue.venueId;

            for (let event of venue.events) {
                if(event.inventories.length==0) continue;

                event = { ...event, venueName, venueId };
                const eventId = event.id;
                const eventName = event.name;

                if (formattedData.hasOwnProperty(eventId)) {
                    if (formattedData[eventId].eventName != eventName) {
                        throw new Error("Inconsistent Data")
                    }
                    else {
                        formattedData[eventId].events.push(event);
                    }
                } else {
                    formattedData[eventId] = { eventName, events: [event] };
                }
            }
            const res = [];
            for (const [key, value] of Object.entries(formattedData)) {
                res.push({ ...value, eventId: key });
            }
            return res;
        }
    } catch(err) {
        throw new Error(err)
    }

}

export const isFirstReservation = async () => {
    const ClientInfoLS_Key_Data = await AsyncStorage.getItem(ClientInfoLS_Key);
    const Events_Clients_Details_Data = await AsyncStorage.getItem(Events_Clients_Details_tempKey);

    if(ClientInfoLS_Key_Data && ClientInfoLS_Key_Data!="null" ){
        return false;
    }

    if(Events_Clients_Details_Data && Events_Clients_Details_Data!="null"){
        const clientsDetails= JSON.parse(Events_Clients_Details_Data);
        ["firstName","lastName","email","phoneNumber"].forEach((key)=>{
            if(!clientsDetails.hasOwnProperty(key)){
                return true;
            }
        })
        return false;
    }

    return true;
}


